import { render, staticRenderFns } from "./system-header.vue?vue&type=template&id=790d043e&scoped=true"
import script from "./system-header.vue?vue&type=script&lang=js"
export * from "./system-header.vue?vue&type=script&lang=js"
import style0 from "./system-header.vue?vue&type=style&index=0&id=790d043e&prod&scoped=true&lang=less"
import style1 from "./system-header.vue?vue&type=style&index=1&id=790d043e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790d043e",
  null
  
)

export default component.exports